import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Check, Shield } from 'lucide-react';
interface UpsellPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function UpsellPopup({
  isOpen,
  onClose
}: UpsellPopupProps) {
  return <AnimatePresence data-id="element-483">
      {isOpen && <>
          {/* Dark Overlay */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[70]" data-id="element-484" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-[75] flex items-center justify-center p-4 pointer-events-none" data-id="element-485">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.9
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="bg-white rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto shadow-2xl pointer-events-auto relative flex flex-col" data-id="element-486">
              {/* Close Button */}
              <button onClick={onClose} className="absolute top-4 right-4 text-white/70 hover:text-white z-10 p-1.5 bg-black/20 hover:bg-black/40 rounded-full transition-colors" aria-label="Cerrar" data-id="element-487">
                <X className="w-5 h-5" data-id="element-488" />
              </button>

              {/* Header Banner */}
              <div className="bg-terracotta p-6 text-center relative overflow-hidden shrink-0 rounded-t-2xl" data-id="element-489">
                <div className="inline-block bg-white text-terracotta text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-3 animate-pulse" data-id="element-490">
                  ⏳ ÚLTIMA OPORTUNIDAD
                </div>
                <h2 className="text-2xl md:text-3xl font-serif font-bold text-cream mb-2" data-id="element-491">
                  🛑 ¡Espera! No te vayas sin esto...
                </h2>
                <p className="text-cream/80 text-sm md:text-base" data-id="element-492">
                  Tienes una oferta especial que no volverá a aparecer
                </p>
              </div>

              {/* Body */}
              <div className="p-6 space-y-6" data-id="element-493">
                <div className="text-center" data-id="element-494">
                  <span className="inline-block bg-red-100 text-red-600 border border-red-200 font-bold px-4 py-1.5 rounded-lg text-sm mb-4 animate-pulse" data-id="element-495">
                    🔥 30% DE DESCUENTO
                  </span>
                  <p className="text-navy/80 font-medium leading-relaxed mb-2" data-id="element-496">
                    Estás a un paso de tener el mapa completo para cuidar a tus
                    padres sin perderte en el camino. Pero sin estas
                    herramientas extra, podrías seguir enfrentando las crisis y
                    conversaciones difíciles sin un plan.
                  </p>
                  <p className="text-navy/60 text-sm" data-id="element-497">
                    El Paquete Completo incluye todo lo que necesitas para
                    empezar esta semana: el libro, los 3 bonos, el kit de
                    emergencia móvil y los guiones para conversaciones
                    incómodas.
                  </p>
                </div>

                {/* What's Included List */}
                <div className="bg-sage/10 rounded-xl p-4 md:p-5 border border-sage/20" data-id="element-498">
                  <ul className="space-y-3" data-id="element-499">
                    {['Libro "Cuando Todo Recae Sobre Ti" (118 páginas)', 'Bono #1: El Guion Anti-Culpa', 'Bono #2: Plantilla "Reparto Sin Pleito"', 'Bono #3: Checklist "Semana de Aire"', 'Kit de Emergencia en el Teléfono — Tu móvil como aliado en urgencias', 'Manual de Conversaciones Incómodas — Guiones para los temas más difíciles'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-500">
                        <Check className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-501" />
                        <span className="text-sm font-medium text-navy/80" data-id="element-502">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                {/* Pricing Block */}
                <div className="text-center space-y-1 bg-navy/5 py-4 rounded-xl border border-navy/10" data-id="element-503">
                  <p className="text-navy/40 line-through font-medium text-lg" data-id="element-504">
                    $18.39 USD
                  </p>
                  <div className="flex items-center justify-center gap-2" data-id="element-505">
                    <span className="text-4xl font-bold text-terracotta" data-id="element-506">
                      $14.79 USD
                    </span>
                    <Shield className="w-6 h-6 text-sage" data-id="element-507" />
                  </div>
                  <p className="text-xs font-bold text-navy/60 uppercase tracking-wider mt-2" data-id="element-508">
                    Precio especial solo disponible en esta pantalla
                  </p>
                </div>

                {/* CTA Buttons */}
                <div className="space-y-4 pt-2" data-id="element-509">
                  <a href="https://tucambiohoy.online/cart/43069616947313:1" target="_blank" rel="noopener noreferrer" onClick={() => {
                if (window.fbq) {
                  window.fbq('track', 'AddToCart', {
                    content_name: 'Paquete Completo (Upsell)',
                    content_type: 'product',
                    value: 14.79,
                    currency: 'USD'
                  });
                }
                onClose();
              }} className="w-full bg-terracotta hover:bg-terracotta/90 text-white font-bold py-4 px-6 rounded-xl shadow-[0_0_20px_rgba(193,105,79,0.4)] hover:shadow-[0_0_25px_rgba(193,105,79,0.6)] transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center text-center animate-[pulse_2s_ease-in-out_infinite]" data-id="element-510">
                    ¡SÍ! Quiero el Paquete Completo por $14.79
                  </a>

                  <div className="text-center" data-id="element-511">
                    <a href="https://tucambiohoy.online/cart/43004276899953:1" target="_blank" rel="noopener noreferrer" onClick={onClose} className="inline-block text-navy/70 hover:text-navy underline text-base transition-colors font-bold" data-id="element-512">
                      No gracias, continuar sin los extras →
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}